import { Grid } from '../style'
import { LoopType, NoAnimation, QuickDecorate, Trim } from './style'

type Props = {
    className?: string
}

const UGEDefaultEditor = ({ className }: Props) => {
    return (
        <Grid className={className}>
            <NoAnimation />
            <Trim />
            <LoopType />
            <QuickDecorate />
        </Grid>
    )
}

export default UGEDefaultEditor
